import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import ThemeContainer from '../../components/ThemeContainer'
import { Colors, Metrics } from '../../Themes'
import Pangea from '../../svg-icons/Pangea'
import Sidebar from '../../components/Sidebar'
import CloseIcon from '../../svg-icons/CloseIcon'
import Burger from '../../svg-icons/Burger'

const Container = styled.div`
  width: auto;
  height: 100vh;
`

const CustomThemeContainer = styled(ThemeContainer)`
  margin-top: ${Metrics.margins.big};
`

const Navbar = styled.div`
  width: 100%;
  height: ${Metrics.components.navbarDefault};
  background-color: ${Colors.white};
  border-bottom: ${Metrics.borders.default};
  box-shadow: ${Metrics.shadows.default};
  text-align: center;
  line-height: ${Metrics.components.navbarDefault};
  position: relative;
`

const FormContainer = styled.div`
  width: 100%;
  height: calc(
    100vh - (${Metrics.components.navbarDefault} + ${Metrics.margins.big} +
          ${Metrics.margins.base})
  );
  background-color: ${Colors.white};
  border: ${Metrics.borders.default};
  border-radius: ${Metrics.borders.defaultRadius};
  box-shadow: ${Metrics.shadows.default};
`

const ScreenContent = styled.div`
  height: 100vh;
  width: 100%;
  background: ${Colors.lightGrey};
  transition: width 0.5s ease;
  float: left;
  &.active {
    width: calc(100% - ${Metrics.components.sidebar});
  }
`

const CustomSidebar = styled(Sidebar)`
  margin-left: -${Metrics.components.sidebar};
  transition: margin-left 0.5s ease;
  z-index: 2;
  float: left;

  &.active {
    margin-left: 0;
  }
`

const CustomCloseIcon = styled(CloseIcon)`
  float: right;

  path {
    fill: ${Colors.white};
  }
`

const CustomLogo = styled(Pangea)`
  position: absolute;
  top: calc((100% - 50px)/2)
  left: calc((100% - 50px)/2);
  cursor: pointer;
  width: 50px;
  height: 50px;
`

const CustomBurger = styled(Burger)`
  float: left;
  margin-top: ${Metrics.margins.medium};
  margin-left: ${Metrics.margins.larger};
  opacity: 1;
  transition: 0.3s opacity ease;

  &.active {
    opacity: 0;
    pointer-events: none;
  }
`

class Agreements extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.toggleSidebar = this.toggleSidebar.bind(this)
  }

  toggleSidebar () {
    this.setState({ open: !this.state.open })
  }

  render () {
    const { children, t, router } = this.props
    return (
      <Container>
        <CustomSidebar
          className={this.state.open && 'active'}
          logo={<CustomCloseIcon onClick={this.toggleSidebar} />}
          links={[
            {
              to: '/agreements/letter_of_intent',
              label: t('Letter of Intent')
            },
            {
              to: '/agreements/collaboration_agreement',
              label: t('NCNDA & Collaboration Agreement')
            },
            {
              to: '/agreements/non_disclosure_and_fee_agreement',
              label: t('Non-Circumvention / Non-Disclosure and Fee Agreement')
            },
            {
              to: '/agreements/ambassador_agreement',
              label: t('NDA & Ambassador Agreement')
            },
            { to: '/agreements/sales_mandate', label: t('Sales Mandate') },
            {
              to: '/agreements/commission_agreement',
              label: t('Commission Agreement')
            },
            {
              to: '/agreements/non_disclosure_agreement',
              label: t('Non Disclosure Agreement')
            }
          ]}
        />
        <ScreenContent className={this.state.open && 'active'}>
          <Navbar>
            <CustomBurger
              onClick={this.toggleSidebar}
              className={this.state.open && 'active'}
            />
            <CustomLogo onClick={() => router.push('/')} />
          </Navbar>
          <CustomThemeContainer>
            <FormContainer>{children}</FormContainer>
          </CustomThemeContainer>
        </ScreenContent>
      </Container>
    )
  }
}

Agreements.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'forms' ], { wait: true })(Agreements)



// WEBPACK FOOTER //
// ./src/pages/Agreements/index.js